import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { TopBar, Container, ViewerSkeleton } from 'splash/components';

const LoadingFlyer = ({
  intl: { messages },
  match: {
    params: { flyerId },
  },
  hideThumbnail,
  logoUrl,
}) => (
  <Container>
    <TopBar title={messages.catalogue_loading} />
    <ViewerSkeleton flyerId={flyerId} hideThumbnail={hideThumbnail} logoUrl={logoUrl} />
  </Container>
);

LoadingFlyer.propTypes = {
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    messages: PropTypes.shape({
      catalogue_loading: PropTypes.string,
    }).isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      flyerId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  hideThumbnail: PropTypes.bool,
  logoUrl: PropTypes.string,
};

LoadingFlyer.defaultProps = {
  hideThumbnail: false,
  logoUrl: null,
};

export default withRouter(injectIntl(LoadingFlyer));
